import { withAuthRedirect } from '../hocs';
import { Panel, PanelHeader, PanelContent } from '../atoms';
import { CoursesFilter, CoursesList } from '../organisms';

const CoursesPage = () => {
  return (
    <Panel>
      <PanelHeader>
        <h1>Courses</h1>
        {/* Filter Not MVP */}
        {/* <CoursesFilter /> */}
      </PanelHeader>
      <PanelContent>
        <CoursesList />
      </PanelContent>
    </Panel>
  );
};

const SecureCoursesPage = withAuthRedirect(CoursesPage);
export { SecureCoursesPage as CoursesPage };
